import './MGMessageBox.css'

import React, { useState } from "react";
import "./MGMessageBox.css";

export default function MGMessageBox({
    maxLength = 500,
    value = "",
    placeholder = "Escreva aqui a sua mensagem",
    onChange,
    isEmpty
}) {
    const [message, setMessage] = useState(value);

    const handleChange = (event) => {
        const newValue = event.target.value.trim();

        setMessage(newValue);

        if (onChange) {
            onChange(newValue);
            isEmpty(newValue == "");
        }

    };

    return (
        <div className="MGMessageBox">

            <textarea
                name="postContent"
                value={message}
                onChange={handleChange}
                maxLength={maxLength}
                placeholder={placeholder}
            />

            <span className="MGMessageBox-counter">
                {message.length}/{maxLength}
            </span>

        </div>
    );
}